module.exports = __webpack_public_path__ + "img/icon_arrow_up.b1794c69.svg";